import { Redirect, useParams } from "react-router-dom"
import slugify from "slugify"
import { CenteredLoadingIndicator } from "../../views/molecules/Molecules"
import { useDispatch, useSelector } from "react-redux"
import React, { useEffect } from "react"
import Library from "../../views/library/Library"
import { getLibraryIsLoaded } from "reducers/library"
import { setCurrentLibraryCategory } from "actions/libraryActions"
import { getBenefitConfiguration } from "reducers/benefitConfiguration"
import { getLibraryCategories } from "derivedSelectors/librarySelectors"

const LibraryContainer = () => {
  const dispatch = useDispatch()
  const params = useParams<{ category?: string }>()

  const categories = useSelector(getLibraryCategories)
  const isLoaded = useSelector(getLibraryIsLoaded)
  const benefitConfiguration = useSelector(getBenefitConfiguration)

  useEffect(() => {
    dispatch(setCurrentLibraryCategory(params.category || null))
  }, [params.category, dispatch, benefitConfiguration])

  return (
    <>
      {!params.category && categories.length > 0 && <Redirect to={`/read/${slugify(categories[0].fields.title)}`} />}

      {!isLoaded ? <CenteredLoadingIndicator /> : <Library />}
    </>
  )
}

export default LibraryContainer
